"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FaChevronCircleRight = exports.FaChevronLeft = exports.FaDotCircleO = exports.FaCircleO = exports.FaEraser = exports.FaRefresh = exports.FaBook = exports.FaBars = exports.FaCog = exports.FaTh = void 0;
const th_1 = __importDefault(require("react-icons/lib/fa/th"));
exports.FaTh = th_1.default;
const cog_1 = __importDefault(require("react-icons/lib/fa/cog"));
exports.FaCog = cog_1.default;
const bars_1 = __importDefault(require("react-icons/lib/fa/bars"));
exports.FaBars = bars_1.default;
const book_1 = __importDefault(require("react-icons/lib/fa/book"));
exports.FaBook = book_1.default;
const refresh_1 = __importDefault(require("react-icons/lib/fa/refresh"));
exports.FaRefresh = refresh_1.default;
const eraser_1 = __importDefault(require("react-icons/lib/fa/eraser"));
exports.FaEraser = eraser_1.default;
const circle_o_1 = __importDefault(require("react-icons/lib/fa/circle-o"));
exports.FaCircleO = circle_o_1.default;
const dot_circle_o_1 = __importDefault(require("react-icons/lib/fa/dot-circle-o"));
exports.FaDotCircleO = dot_circle_o_1.default;
const chevron_left_1 = __importDefault(require("react-icons/lib/fa/chevron-left"));
exports.FaChevronLeft = chevron_left_1.default;
const chevron_circle_right_1 = __importDefault(require("react-icons/lib/fa/chevron-circle-right"));
exports.FaChevronCircleRight = chevron_circle_right_1.default;
